<template>
<div :class="vertical ? 'tabs__vert--container' : 'tabs__horz--container'" :id="id">
   <div :class="vertical ? 'tabs__vert--buttons' : 'tabs__horz--buttons'">
      <div v-for="(tab, i) in tabs" :key="i" @click="tabChange(i)" :class="tabClasses[i]" >
         <h6>{{tab.$props.name}}</h6>
      </div>
   </div>
   <div :class="tabContentClasses">
      <slot></slot>
   </div>
</div>
</template>

<script>
export default {
   data() {
      return {
         tabs: [],
         activeTab: null
      }
   },
   props: {
      id: { type: String, default: null },
      vertical: { type: Boolean, default: false },
   },
   created() {
      this.tabs = this.$children;
   },
   methods: {
      tabChange(i) {
         this.activeTab = i

         for (let j = 0; j < this.tabs.length; j++) {
            this.tabs[j]._data.isActive = false
         }

         this.tabs[i]._data.isActive = true
      }
   },
   computed: {
      tabClasses() {
         const { activeTab } = this
         const active = activeTab != null ? activeTab : 0
         let classes = []

         for (let i = 0; i < this.tabs.length; i++) {
            classes[i] = [
               'tab__button',
               'js-tab__button',
               i == active ? 'active' : null,
               this.tabs[i].$props.disabled ? 'disabled' : null
            ]
         }

         return classes
      },
      tabContentClasses() {
         return [
            this.vertical ? 'tabs__vert--content' : 'tabs__horz--content'
         ]
      }
   }
}
</script>

<style lang="scss" scoped>
@import '~/assets/SCSS/Base/00_functions.scss';
@import '~/assets/SCSS/Base/01_variables.scss';
@import '~/assets/SCSS/Base/02_mixins.scss';

@import '~/assets/SCSS/Elements/tabs.scss';
</style>
